export default __webpack_public_path__ + "static/media/avatar11.7f86f21e.svg";